import { render, staticRenderFns } from "./CampaignPicker.vue?vue&type=template&id=f867d352&lang=pug&"
import script from "./CampaignPicker.vue?vue&type=script&lang=js&"
export * from "./CampaignPicker.vue?vue&type=script&lang=js&"
import style0 from "./CampaignPicker.vue?vue&type=style&index=0&id=f867d352&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports